import request from '@shared/utils/request'

/** 上传文件地址 */
export const uploadUrl = `${process.env.npm_config_baseapi || import.meta.env.VITE_BASE_API}/sys-oss/upload`

/** 删除文件 */
export function removeImages(params) {
  return request({
    url: '/sys-oss/delete',
    method: 'get',
    params
  })
}

/** 上传文件 */
export function uploadFile(data, params) {
  return request({
    url: '/sys-oss/upload',
    requestType: 'upload',
    method: 'post',
    data,
    onUploadProgress: (event) => {
      const complete = parseInt(((event.loaded / event.total) * 100) | 0, 10)

      params.onProgress({ percent: complete })
    }
  })
}

/** 上传文件, 简易版，封装formData */
export const uploadSimple = async (params) => {
  const { file, filename = 'file' } = params
  const formData = new FormData()
  formData.append(filename, file)
  return await uploadFile(formData, params)
}

export function getPrefix() {
  return request({
    url: '/sys-oss/getPrefix',
    method: 'get'
  })
}
